import { environment } from 'src/environments/environment';

export class SakpModuleUtils {

    static getSakpServerUrl(): string {
        return (environment as any)?.sakpServerUrl;
    }

}

export function extractFilenameFromContentDisposition(header: string | null): string | null {
    if (!header) return null;

    const decodedHeader = decodeURIComponent(header);
    const filenameMatch = /filename\*?=(?:UTF-8''|["'])?([^"';\n]*)/i.exec(decodedHeader);

    return filenameMatch?.[1] || null;
}
